export const BoardGradient = ({colorOptions, selectedColor, handleSelectColor}) => {
    return (
        <div className="backgroundPicker">
            <div className="backgroundPicker__section">
                <div className="backgroundPicker__sectionTop">
                    <h4>Colors</h4>
                    <button type="button" className="backgroundPicker__viewMore">
                        View more
                    </button>
                </div>

                <div className="backgroundPicker__grid backgroundPicker__grid--colors">
                    {colorOptions.map((el, index) => (
                        <button
                            key={index}
                            type="button"
                            className={`backgroundPicker__color ${
                                selectedColor === el ? "active" : ""
                            }`}
                            style={{background: el.color}}
                            onClick={() => handleSelectColor(el)}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}